import { isNonEmptyArray } from './js-utils-3.js';

const searchFormDrawer = document.forms?.searchFormDrawer;
const searchFormDrawerInput = searchFormDrawer?.querySelector('input[name="q"]');
const searchFormDrawerBtnReset = searchFormDrawer?.querySelector('[data-search-reset]');

const searchFormPage = document.forms?.searchFormPage;
const searchFormPageInput = searchFormPage?.querySelector('input[name="q"]');
const searchFormPageBtnReset = searchFormPage?.querySelector('[data-search-reset]');

searchFormDrawerInput?.addEventListener('input', handleSearchInput);
searchFormDrawerBtnReset?.addEventListener('click', handleSearchReset);

searchFormPageInput?.addEventListener('input', handleSearchInputLite);
searchFormPageBtnReset?.addEventListener('click', handleSearchReset);
let controller;

async function handleSearchInput(e) {
  const target = e.target;

  const searchBox = target?.closest('[data-search-box]');
  const searchBoxResults = searchBox?.querySelector('[data-search-results]');
  if (!searchBoxResults) return;

  const query = target?.value.trim();
  // При коротких запитах — ховаємо результати
  if (query.length < 3) {
    searchBoxResults.innerHTML = '';
    searchBox?.classList.remove('active');
    return;
  }

  // Якщо є попередній запит — відміняємо
  if (controller) controller.abort();
  controller = new AbortController();

  try {
    const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`, { signal: controller.signal });
    const data = await res?.json();
    const products = data?.resources?.results?.products || [];
    const markupSearchResults = createMarkupSearchResults(products, query);
    searchBoxResults.innerHTML = markupSearchResults;
    searchBox?.classList.add('active');
  } catch (err) {
    if (err.name !== 'AbortError') console.error(err);
  }
}

function handleSearchReset(e) {
  const target = e.target;
  if (!target?.hasAttribute('data-search-reset')) return;

  const searchBox = target?.closest('[data-search-box]');
  const searchInput = searchBox?.querySelector('input[name="q"]');
  const searchBoxResults = searchBox?.querySelector('[data-search-results]');
  if (!searchInput || !searchBoxResults) return;

  searchBox?.classList?.remove('active');
  searchInput.value = '';
  searchBoxResults.innerHTML = '';
}

function handleSearchInputLite(e) {
  const target = e.target;

  const searchBox = target?.closest('[data-search-box]');
  const searchBoxResults = searchBox?.querySelector('[data-search-results]');
  if (!searchBoxResults) return;

  const query = target?.value.trim();
  if (query.length > 0) {
    searchBox?.classList.add('active');
  } else {
    searchBox?.classList.remove('active');
  }
}

function createMarkupSearchResults(products, query) {
  if (!isNonEmptyArray(products)) {
    const markupInfo = `
      <div class="search-results-info">
        <p>0 results for "${query}"</p>
      </div>
  `;
    return markupInfo;
  }

  const markupList = products?.map((i) => {
    const { title, image, url, price, compare_at_price_min } = i ?? {};
    const compareAtPrice = compare_at_price_min !== '0.00';
    const fullPrice = compareAtPrice ? `<span class="current">${price}€</span><span class="old">${compare_at_price_min}€</span>` : `<span class="current">${price}€</span>`;

    return `
      <li class="search-results__item search-results-item">
        <a class="search-results-item__link" href="${url}">
          <img class="search-results-item__img" src="${image}" alt="${title}" width="60" height="60" decoding="async">
          <div class="search-results-item__desc">
            <h3 class="search-results-item__title">${title}</h3>
            <p class="search-results-item__price">${fullPrice}</p>
          </div>

          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none">
            <path d="M3.68725 7.28242C3.59178 7.1922 3.47947 7.12168 3.35674 7.07486C3.23401 7.02804 3.10327 7.00586 2.97196 7.00957C2.84066 7.01329 2.71138 7.04283 2.59149 7.09651C2.47161 7.15019 2.36347 7.22695 2.27325 7.32242C2.18303 7.41789 2.1125 7.5302 2.06569 7.65293C2.01887 7.77566 1.99669 7.90641 2.0004 8.03771C2.00411 8.16901 2.03365 8.2983 2.08733 8.41818C2.14101 8.53807 2.21778 8.6462 2.31325 8.73642L11.3132 17.2364C11.4989 17.412 11.7447 17.5098 12.0002 17.5098C12.2558 17.5098 12.5016 17.412 12.6872 17.2364L21.6882 8.73642C21.7858 8.6468 21.8646 8.53869 21.92 8.41836C21.9754 8.29803 22.0064 8.16789 22.0111 8.0355C22.0158 7.9031 21.9942 7.77109 21.9474 7.64714C21.9007 7.52318 21.8298 7.40975 21.7388 7.31343C21.6479 7.21711 21.5387 7.13982 21.4176 7.08605C21.2965 7.03228 21.166 7.00311 21.0335 7.00023C20.9011 6.99734 20.7694 7.0208 20.6461 7.06925C20.5228 7.11769 20.4103 7.19015 20.3153 7.28242L12.0002 15.1344L3.68725 7.28242Z"></path>
          </svg>
        </a>
      </li>
    `;
  });

  const markup = `
    <div class="search-results-info">
      <p>Results for "${query}"</p>
      <a href="/search?type=product&q=${encodeURIComponent(query)}">View all results</a>
    </div>
    <ul class="search-results__list"> ${markupList} </ul>
  `;

  return markup;
}
